import axios from 'axios';
import qs from 'qs';

export async function Post(action, uri, request_data) {

    // POST
    let error = [];
    let response = [];
    let is_success = false;
    // console.log(JSON.stringify(request_data));
    // pのGETがあればそれも送る
    const query = new URLSearchParams(window.location.search);
    const p = query.get('p');
    // console.log(p);
    if (p) {
        // console.log('ok');
        action = 'login';
        request_data['p'] = p;
    }
    // 保持済みsec（Cookieが使えないクロスオリジン配信でも認証を継続するためBearerで送る）
    const storedSec = (typeof localStorage !== 'undefined' && localStorage.getItem('sec')) || '';
    try{
        var domain = '';
        if (process.env.REACT_APP_IS_DEV !== 'true') {
            // 本番: 新システムD1ゲートウェイ本番ドメイン（移行済→D1／未移行→ゲートウェイがPHPへ自動転送）
            domain = "https://api.laundrypack.app/proxy";
        }else{
            // 開発: 隔離されたdev worker（dev D1 laundrypack-now-dev を見る／本番に書き込まない）
            domain = "https://laundrypack-now-api-dev.laundrypack.workers.dev/proxy";
        }
        await axios({
            withCredentials: true, // ←これを追加
            method: "POST",
            url: domain ,
            data: qs.stringify({
                'action': action,
                'uri': uri,
                'p': p,
                'request_data': JSON.stringify(request_data),
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...(storedSec ? { 'Authorization': `Bearer ${storedSec}` } : {}),
            },
        })
        .then((res) => {
            // console.log(res);
            response = res;
            is_success = true;
            // ログイン/認証応答でsecを受け取ったら保持（以降Bearerで送信）
            if (res.data && res.data.sec) {
                try { localStorage.setItem('sec', res.data.sec); } catch (_) {}
            }
            // secエラーならリダイレクト
            if (response.data.result === 0 && response.data.error_code === 'E999') {
                try { localStorage.removeItem('sec'); } catch (_) {}
                window.location.href = '/login';
            }
        })
        .catch((e) => {
            // console.log(e);
            error['result'] = 0;
            error['error_code'] = 'E000';
            error['error_message'] = '通信エラーです。しばらくして再度お試しください。';
        });
    } catch (error) {
        error['result'] = 0;
        error['error_code'] = 'E000';
        error['error_message'] = '通信エラーです。しばらくして再度お試しください。';
    }
    if (is_success) {
        return response.data;
    } else {
        return error;
    }
}

export async function PostFile(action, uri, request_data, files = []) {
    let result = { result: 0, error_code: 'E000', error_message: '通信エラーです。しばらくして再度お試しください。' };

    try {
        const domain = process.env.REACT_APP_IS_DEV !== 'true'
            ? "https://api.laundrypack.app/proxy/image"
            : "https://laundrypack-now-api-dev.laundrypack.workers.dev/proxy/image";

        const formData = new FormData();

        // ✅ ファイルサイズ合計を計算（最大32MB制限）
        let totalFileSize = 0;
        files.forEach(file_data => {
        if (file_data.file instanceof File) {
            totalFileSize += file_data.file.size;
        }
        });

        const maxSizeBytes = 32 * 1024 * 1024; // 32MB
        if (totalFileSize > maxSizeBytes) {
        alert(`ファイルの合計サイズが上限（32MB）を超えています。\n現在の合計: ${(totalFileSize / (1024 * 1024)).toFixed(2)}MB`);
        result.error_message = 'ファイルサイズが大きすぎます。';
        return result;
        }

        // ファイル追加（base64はNG。必ず File オブジェクトにしておく）
        files.forEach(file_data => {
            if (file_data.file instanceof File) {
            formData.append('img_' + file_data.key_name, file_data.file);
            } else {
            console.warn(`無効なファイル形式: ${file_data.key_name}`);
            }
        });

        // 重いデータを含まないよう request_data をフィルタリング（例：option.imagesは除外）
        const safe_request_data = JSON.parse(JSON.stringify(request_data, (key, value) => {
            if (key === 'images') return undefined; // 明示的に除外
            return value;
        }));

        formData.append('action', action);
        formData.append('uri', uri);
        formData.append('request_data', JSON.stringify(safe_request_data));

        const storedSec = (typeof localStorage !== 'undefined' && localStorage.getItem('sec')) || '';
        const res = await axios.post(domain, formData, {
            withCredentials: true,
            headers: {
            'Content-Type': 'multipart/form-data',
            ...(storedSec ? { 'Authorization': `Bearer ${storedSec}` } : {}),
            },
            timeout: 30000, // タイムアウト追加（30秒）
        });

        if (res.data.result === 0 && res.data.error_code === 'E999') {
            try { localStorage.removeItem('sec'); } catch (_) {}
            window.location.href = '/login';
            return;
        }

        return res.data;
    } catch (e) {
        console.error('PostFile error:', e);
        return result;
    }
  }
